import React from 'react';
import { css, DNA, Flex, Text } from '@dna/react';
import { ViewStyleProps } from "@dna/react/src/types";
import { BadgeType, IStatusBadgeProps } from "./BadgeType";
import { EmedStyle } from "../style/emed.style";
import { Box } from '@material-ui/core';

import styles from './StatusBadge.module.scss';

function getPadgeCssStyle(backgroundColourCssProperty: string, colourCssProperty: any, widthCssProperty: any, cursor: string|undefined) {
    var padgeCssProps: any = {
        display: "flex",
        justifyContent: "center",
        fontSize: DNA.tokens.dimension.font[50],
        fontWeight: "bold",
        alignItems: "center",
        width: "fit-content",
        height: "24px",
        borderRadius: "2px",
        cursor: cursor,
        paddingLeft: 8,
        paddingRight: 8,
        letterSpacing: "0.1em",
        lineHeight: "16px"
    };

    if (backgroundColourCssProperty != null) {
        padgeCssProps['background'] = backgroundColourCssProperty;
    }
    if (colourCssProperty != null) {
        padgeCssProps['color'] = colourCssProperty;
    }
    if (widthCssProperty != null) {
        padgeCssProps['width'] = widthCssProperty;
    }
    return css({
        ...padgeCssProps
    });
}

export const CautionBadge = (props: any) => {
    return (
        <Box className={`${styles.statusBadge} ${styles.cautionBadge}`}>
            {props.children}
        </Box>
    );
}

export const StandardBadge = (props: any) => {
    return (
        <Box className={`${styles.statusBadge} ${styles.standardBadge}`}>
            {props.children}
        </Box>
    );
}

export const CriticalBadge = (props: any) => {

    return (
        <Box className={`${styles.statusBadge} ${styles.criticalBadge}`}>
            {props.children}
        </Box>
    );
}

export const NewMedBadge = (props: any) => {
    return (
        <Box className={`${styles.statusBadge} ${styles.newMed}`}>
            {props.children}
        </Box>
    );
}

export const ExpiredBadge = (props: any) => {
    return (
        <Box className={`${styles.statusBadge} ${styles.expiredBadge}`}>
            {props.children}
        </Box>
    );
}

export const ExpiringBadge = (props: any) => {
    return (
        <Box className={`${styles.statusBadge} ${styles.expiringBadge}`}>
            {props.children}
        </Box>
    );
}

export const SuccessBadge = (props: any) => {
    return (
        <Box className={`${styles.statusBadge} ${styles.successBadge}`}>
            {props.children}
        </Box>
    );
}

export const GreyBadge = (props: any) => {
    return (
        <Box className={`${styles.statusBadge} ${styles.greyBadge}`}>
            {props.children}
        </Box>
    );
}

export const StatusBadge = (props: IStatusBadgeProps & { children: any }) => {
    let styles: string = '';
    let backgroundCssProperty: any;
    let colourCssProperty: any;
    let widthCssProperty: any;

    if (props.type != null) {
        let backgroundColorMap = new Map<BadgeType, string>();
        backgroundColorMap.set(BadgeType.Critical, DNA.tokens.color.orange.dark);
        backgroundColorMap.set(BadgeType.Caution, DNA.tokens.color.yellow.dark);
        backgroundColorMap.set(BadgeType.Info, DNA.tokens.color.blue.mid);
        backgroundColorMap.set(BadgeType.Standard, DNA.tokens.color.purple.light);

        backgroundCssProperty = backgroundColorMap.get(props.type);
    }
    if (props.backgroundColour != null) {
        backgroundCssProperty = props.backgroundColour;
    }
    if (props.fontColour != null) {
        colourCssProperty = props.fontColour;
    }
    if (props.width != null) {
        widthCssProperty = props.width;
    }

    styles = getPadgeCssStyle(backgroundCssProperty, colourCssProperty, widthCssProperty, props.cursor);

    return (

        <div className={styles} onClick={props.onClick}>
            {props.children}
        </div>
    );
}

export const NewAdmissionBadge = (props: any) => {

    return <Box className={`${styles.statusBadge} ${styles.newAdmission}`}>
            {props.children}
        </Box>
        
}

export const ComplementaryBadge = () => {
    return (
        <Box className={`${styles.complementaryBadge}`}>
            {"Complementary"}
        </Box>
    );
}

export const PhoneOrderBadge = () => {
    return (
        <Box className={`${styles.statusBadge} ${styles.phoneOrderBadge}`}>
            {"Phone order"}
        </Box>
    );
}